import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', name: 'Login', component: () => import('@/views/Login.vue') },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/dashboard',
    children: [
      { path: 'dashboard', name: 'Dashboard', component: () => import('@/views/Dashboard.vue') },
      { path: 'activity', name: 'Activity', component: () => import('@/views/Activity.vue') },
      { path: 'activity/add', name: 'ActivityAdd', component: () => import('@/views/ActivityForm.vue') },
      { path: 'activity/edit/:id', name: 'ActivityEdit', component: () => import('@/views/ActivityForm.vue') },
      { path: 'banner', name: 'Banner', component: () => import('@/views/Banner.vue') },
      { path: 'poster-template', name: 'PosterTemplate', component: () => import('@/views/PosterTemplate.vue') },
      { path: 'appointment', name: 'Appointment', component: () => import('@/views/Appointment.vue') },
      { path: 'user', name: 'User', component: () => import('@/views/User.vue') },
      { path: 'config', name: 'Config', component: () => import('@/views/Config.vue') }
    ]
  }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('adminToken')
  if (!token && to.path !== '/login') {
    next('/login')
  } else {
    next()
  }
})

export default router
